const view = { index: 1, create: 2, edit: 3 }
export default {
  data: () => ({
    view: view.index,
    dialog: false,
    search: '',
    items: [],
    editedIndex: -1,
    editedItem: {},
    beforeEditedItem: {},
    defaultItem: {},
    resBody: {},
    saving: false
  }),
  methods: {
    initialize() {
      this.beforeInitialize()
      this.$store.commit('loader/change_dialog', true)
      this.$http.get(`api/${this.entity}`).then(
        res => {
          this.resBody = res.body
          this.items = res.body.dados
          this.afterInitialize()
          this.$store.commit('loader/change_dialog', false)
        }, (err) => {
          this.afterInitialize()
          this.$store.commit('loader/change_dialog', false)
        }
      )
    },
    create() {
      this.beforeCreate()
      this.dialog = true
      this.view = view.create
      this.editedIndex = 0
      this.afterCreate()
      this.afterDialog()
    },
    editItem(item) {
      this.beforeEdit(item)
      Object.assign(this.editedItem, JSON.parse(JSON.stringify(item)))
      Object.assign(this.beforeEditedItem, JSON.parse(JSON.stringify(item)))
      this.dialog = true
      this.view = view.edit
      this.editedIndex = this.items.indexOf(item)
      this.$store.commit('loader/change_dialog', false)
      this.afterEdit()
      this.afterDialog()
    },
    deleteItem(item, id = item.id, confirmation = false) {
      if (confirmation) {
        confirmation = prompt(
          `Esta ação pode levar à perda de dados. Para evitar ações acidentais, solicitamos que você confirme sua intenção.\nDigite "${(item.id_texto || item.name)}" para prosseguir ou feche este modal para cancelar.`)

        if (!confirmation) {
          return
        } else if (confirmation !== (item.id_texto || item.name)) {
          alert('Palavra informada inválida')
          return
        }

        var already_confirmed = true
      }

      const index = this.items.indexOf(item)
      if (already_confirmed || confirm(this.translate('system.alert.delete'))) {
        if (this.saving) return
        this.saving = true
        this.beforeDelete()
        this.$store.commit('loader/change_dialog', true)
        this.$http.delete(`api/${this.entity}/${id}`).then(
          res => {
            this.items.splice(index, 1)
            this.afterDelete()
            this.saving = false
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' deletado com sucesso!',
              color: 'success',
              dialog: true
            })
          },
          error => {
            this.saving = false
            this.$store.commit('loader/change_dialog', false)

            let text = 'Não foi possível deletar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.'
            let timeout = 3000
            if (error.body.message.includes('23000-1451')) {
              text = error.body.message
              timeout = 10000
            }

            this.$store.commit('snackbar/change_values', {
              text,
              timeout,
              color: 'error',
              dialog: true
            })
          }
        )
      }
    },
    close(time = 0, to = 1) {
      this.beforeClose()
      this.dialog = to !== 1
      this.$store.commit('loader/change_dialog', false)
      setTimeout(() => {
        if (to !== 3) {
          this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(this.defaultItem)))
          this.editedIndex = -1
        }
        this.view = to
        this.afterClose()
      }, time)
    },
    _collectPDateValidators() {
      const validators = []
      const traverse = (vm) => {
        vm.$children.forEach(child => {
          if (child.$refs && child.$refs.menu !== undefined) {
            validators.push(child.$validator)
          }
          traverse(child)
        })
      }
      traverse(this)
      return validators
    },
    save(route = this.entity, id = this.editedItem.id, data = this.editedItem, to = 1, unshift = false) {
      if (this.saving) return
      this.saving = true
      const childValidators = this._collectPDateValidators()
      Promise.all([
        this.$validator.validateAll(),
        ...childValidators.map(v => v.validateAll())
      ]).then(results => {
        const result = results.every(Boolean)
        if (!result) {
          this.saving = false
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'error',
            dialog: true
          })
        } else {
          this.$store.commit('loader/change_dialog', true)

          if (this.beforeSave() === false) {
            this.saving = false
            this.$store.commit('loader/change_dialog', false)
            return
          }

          if (this.view === 2) {
            this.$http.post('api/' + route, data).then(
              res => {
                console.log('res.body', res.body)
                console.log('this.items', this.items)
                if (unshift) {
                  this.items.unshift(res.body.dados)
                } else {
                  this.items.push(res.body.dados)
                }
                this.resBody = res.body
                this.afterSave(res)
                this.saving = false

                // this.$store.commit('loader/change_dialog', false)
                this.$store.commit('snackbar/change_values', {
                  text:
                    'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' incluído com sucesso!',
                  color: 'success',
                  dialog: true
                })

                this.close(0, to)
              }, (err) => {
                this.saving = false
                this.$store.commit('loader/change_dialog', false)
                this.$store.commit('snackbar/change_values', {
                  text:
                    'Não foi possível incluir o registro de ' +
                    this.translate('table.' + this.entity + '.title')[0] +
                    ', reporte o erro.',
                  color: 'error',
                  dialog: true
                })
                this.close(0, to)
              }
            )
          } else if (this.view === 3) {
            let index = this.editedIndex
            this.$http.put('api/' + route + '/' + id, data).then(
              res => {
                let item = this.items.find((val) => { return val['id'] == res.body.dados['id'] })

                if (item) { // Adicionada verificação pois ao criar um novo contribuinte da tela de pessoas os itens aparecem com o filtro inicial, portanto nem sempre o novo contribuinte estará presente nos primeiros 25 itens
                  Object.assign(item, res.body.dados)
                  this.resBody = res.body
                }

                this.afterSave()
                this.saving = false

                this.$store.commit('loader/change_dialog', false)
                this.$store.commit('snackbar/change_values', {
                  text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' editado com sucesso!',
                  color: 'success',
                  dialog: true
                })

                this.close(0, to)
              }, (err) => {
                this.saving = false
                this.$store.commit('loader/change_dialog', false)
                this.$store.commit('snackbar/change_values', {
                  text:
                    'Não foi possível editar o registro de ' +
                    this.translate('table.' + this.entity + '.title')[0] +
                    ', reporte o erro.',
                  color: 'error',
                  dialog: true
                })
                this.close(0, to)
              }
            )
          } else {
            this.saving = false
          }
        }
      }, () => {
        this.saving = false
      })
    },
    saveNew() {
      const childValidators = this._collectPDateValidators()
      Promise.all([
        this.$validator.validateAll(),
        ...childValidators.map(v => v.validateAll())
      ]).then(results => {
        const result = results.every(Boolean)
        if (!result) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'error',
            dialog: true
          })
        } else {
          this.save(this.entity, this.editedItem.id, this.editedItem, 2)
          setTimeout(() => {
            this.create()
          }, 0)
        }
      })
    },
    saveEdit() {
      const childValidators = this._collectPDateValidators()
      Promise.all([
        this.$validator.validateAll(),
        ...childValidators.map(v => v.validateAll())
      ]).then(results => {
        const result = results.every(Boolean)
        if (!result) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'error',
            dialog: true
          })
        } else {
          this.save(this.entity, this.editedItem.id, this.editedItem, 3)
          setTimeout(() => {
            this.editItem(this.resBody)
          }, 1000)
        }
      })
    },
    editValue(route, id, value) {
      this.$store.commit('loader/change_dialog', true)
      this.$http.put('api/' + route + '/' + id, value).then(
        res => {
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: 'Registro' + (name === '' ? name : ' de ' + name) + ' editado com sucesso!',
            color: 'success',
            dialog: true
          })
        },
        () =>
          function () {
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível editar o registro' + (name === '' ? ' de ' + name : name) + ', reporte o erro.',
              color: 'error',
              dialog: true
            })
          }
      )
    },
    beforeEdit(item) { },
    afterEdit() { },
    beforeCreate() { },
    afterCreate() { },
    beforeSave() { },
    afterSave() { },
    beforeInitialize() { },
    afterInitialize() { },
    beforeDelete() { },
    afterDelete() { },
    afterDialog() { },
    afterClose() { },
    beforeClose() { }
  },
  computed: {
    formTitle() {
      switch (this.view) {
        case 1:
          return this.translate('system.title.consult') + this.translate('table.' + this.entity + '.title')[1]
        case 2:
          return this.translate('system.title.include') + this.translate('table.' + this.entity + '.title')[0]
        case 3:
          return this.translate('system.title.edit') + this.translate('table.' + this.entity + '.title')[0]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/crud.js